import { createAction } from '@lingoda/core';
import type { Currency } from './models';

export const setCurrency = createAction<Currency>('currency/SET_CURRENCY');
